import React, { useState, useEffect } from 'react';
import { $t } from '@/modules/i18n';
import { Popup, Toast} from 'antd-mobile';
import { postSubscription } from '@/modules/request';
import back from '@/assets/images/back.svg';
import triangluarTopArrow from '@/assets/images/triangluar-top-arrow.svg';
import checkWhite from '@/assets/images/check-white.svg';
import pickerBack from '@/assets/images/subscribe-mobile-back.svg';
import pickerClose from '@/assets/images/subscribe-mobile-close.svg';
import successIcon from '@/assets/images/success.png';
import errorIcon from '@/assets/images/error.png';


const SubscribePicker = ({options = [], selectType, confirmOptions, title, setPickerValue, validate}) => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  const [chooseValues, setChooseValues] = useState([]);
  // const [chooseLabels, setChooseLabels] = useState([]);

  const cancel = () => {
    // updateChooseLabels();
    setChooseValues([...confirmOptions]);
    setVisible(false);
    validate();
  }

  const confirmPicker = () => {
    const labels = getChooseLabels(chooseValues);
    setText(labels.map(item => $t(item)).join(', '));
    setPickerValue(chooseValues);
    setVisible(false);
    validate();
  }

  const getChooseLabels = (chooseValues) => {
    const labels = [];
    options.map(option => {
      if (chooseValues.indexOf(option.value) !== -1) labels.push(option.text);
    });
    return labels;
  }

  const chooseOption = (option) => {
    const index = chooseValues.indexOf(option.value);
    if (selectType === 'multiple') {
      if (index !== -1) {
        chooseValues.splice(index, 1);
      } else {
        chooseValues.push(option.value);
      }
    } else {
      if (index !== -1) {
        chooseValues.pop();
        setChooseValues([...chooseValues]);
        return;
      }
      if (chooseValues.length === 1) {
        chooseValues.pop();
      }
      chooseValues.push(option.value);
    }
    setChooseValues([...chooseValues]);
  }

  return (
    <div className="picker-container">
      <div onClick={() => {setVisible(true);}} className="picker-cell">
        <span className="picker-text">{text}</span>
        <img src={triangluarTopArrow} className="select-down"/>
      </div>
      <Popup
        getContainer={null}
        maskStyle={{zIndex: 99}}
        visible={visible}
        bodyStyle={{height: '78%'}}
      >
        <div className="title-wrapper">
          <span className="back" onClick={cancel}>
            <img src={pickerBack} className="back"/>
          </span>
          <div className="title">{title}</div>
          <span className="close" onClick={cancel}>
            <img src={pickerClose} className="close" />
          </span>
        </div>
        <div className="content-wrapper">
          {
            options.map(option => {
              return (
                <div className="picker-item" key={option.text || option.transify_key} onClick={(e) => {e.stopPropagation(); chooseOption(option);}}>
                  <div className={chooseValues.indexOf(option.value) !== -1 ? 'reat active' : 'reat'}>
                    <img style={{display: chooseValues.indexOf(option.value) !== -1 ? 'block' : 'none'}} src={checkWhite} className="check-icon"/>
                    {/* <svg-icon v-show="chooseValues.indexOf(option.value) !== -1" className="check-icon" iconName="check-white"/> */}
                  </div>
                  <span className="text">{$t(option.text)}</span>
                </div>
              )
            })
          }
        </div>
        <div className="confirm-container">
          <div onClick={(e) => {e.stopPropagation(); confirmPicker();}} className="confirm">{$t('microsite_modal_btn_confirm')}</div>
        </div>
      </Popup>
    </div>
  )
}

export default ({ visible, setVisible, locationList = [], levelList = [], deptList = [] }) => {

  const [pickerOpen, setPickerOpen] = useState('');

  const initForm = {
    name: '',
    email: '',
    departments: [],
    levels: [],
    regions: [],
    check: true
  }

  const [message, setMessage] = useState({
    name: '',
    email: '',
    departments: '',
    levels: '',
    regions: ''
  });

  const [form, setForm] = useState(initForm);

  useEffect(() => {
    if(visible) {
      setForm({...initForm});
    }
  }, [visible])

  const closePopup = () => {
    setVisible(false);
  }

  const inputFoucs = (prop) => {
    message[prop] = '';
    setMessage({
      ...message
    });
  }

  const changeValue = (prop, event) => {
    form[prop] = event.target.value;
    setForm({
      ...form
    });
  }

  const setPickerValue = (prop, value) => {
    form[prop] = [...value];
    setForm({
      ...form
    });
  }

  const validateAll = () => {
    let flag = true;
    Object.keys(form).forEach(item => {
      if (!validate(item, true)) flag = false;
    });
    return flag;
  }

  const validate = (prop, args) => {
    const isSubmited = !args || typeof args === 'boolean' ? args : [...args][0];
    const formItem = form[prop];
    let flag = true;
    if (prop === 'name') {
      if (formItem.trim().length === 0) {
        message.name = 'microsite_modal_subscribe_name_prompt_1';
        flag = false;
      } else if (formItem.length > 100) {
        message.name = 'microsite_modal_subscribe_name_prompt_2';
        flag = false;
      } else {
        message.name = '';
      }
    } else if (prop === 'email') {
      const parttern = /^[A-Za-z0-9][A-Za-z0-9._-]*@([a-zA-Z0-9_-]+\.)+[a-zA-Z0-9]+$/;
      if (formItem.trim().length > 100) {
        message.email = 'microsite_modal_subscribe_email_prompt_1';
        flag = false;
      } else if (formItem.trim().length === 0) {
        message.email = 'microsite_modal_subscribe_email_prompt_2';
        flag = false;
      } else if (!parttern.test(formItem)) {
        message.email = 'microsite_modal_subscribe_email_prompt_3';
        flag = false;
      } else {
        message.email = '';
      }
    } else if (prop === 'departments') {
      if (formItem.length === 0) {
        message.departments = 'microsite_modal_subscribe_dept_prompt_1';
        flag = false;
      } else {
        message.departments = '';
      }
    } else if (prop === 'regions') {
      if (formItem.length === 0) {
        message.regions = 'microsite_modal_subscribe_location_prompt_1';
        flag = false;
      } else {
        message.regions = '';
      }
    } else if (prop === 'levels') {
      if (formItem.length === 0) {
        message.levels = 'microsite_modal_subscribe_level_prompt_1';
        flag = false;
      } else {
        message.levels = '';
      }
    } else if (prop === 'check') {
      if (!formItem) flag = false;
    }
    setMessage({
      ...message
    });

    return flag;
  }

  const handleSubmit = async () => {
    if (!validateAll()) {
      return;
    }
    const level = form.levels;
    const Subscription = {
      name: form.name.trim(),
      email: form.email.trim(),
      department_list: form.departments,
      location_list: form.regions,
      level: level[0]
    };
    try {
      const res = await postSubscription(Subscription);
      if (res.code === 0) {
        // Toast.success($t('microsite_toast_subscribe_success'));
        Toast.show({
          icon: <img style={{width: 40, marginBottom: 12}} src={successIcon}/>,
          duration: 2000,
          maskStyle: { background: 'rgba(0, 0, 0, 0.4)' },
          content: $t('microsite_toast_subscribe_success')
        })
        closePopup();
      } else {
        Toast.show({
          icon: <img style={{width: 40, marginBottom: 12}} src={errorIcon}/>,
          duration: 2000,
          maskStyle: { background: 'rgba(0, 0, 0, 0.4)' },
          content: $t('microsite_toast_subscribe_fail')
        })
      }
    } catch(e) {
      console.error(e);
      Toast.show({
        icon: <img style={{width: 40, marginBottom: 12}} src={errorIcon}/>,
        duration: 2000,
        maskStyle: { background: 'rgba(0, 0, 0, 0.4)' },
        content: $t('microsite_toast_subscribe_fail')
      })
    }
  }

  return (
    <Popup
      getContainer={null}
      className="subscribe-popup"
      visible={visible}
      mask={false}
      // onMaskClick={() => {
      //   setVisible(false)
      // }}
    >
      {
        visible ? (
          <>
            <div onClick={closePopup} className="back-wrapper">
              <img src={back} className="back-icon"/>
              <span>{$t('microsite_modal_btn_back')}</span>
            </div>
            <div className={'content-wrapper ' + pickerOpen}>
              <div className="title-wrapper">
                <h2>{$t('microsite_modal_subscribe_title')}</h2>
              </div>
              <form className="form-container">
                <div className="form-item">
                  <div className="label-container">
                    <span className={message.name === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_1')}</span>
                    <span style={{color: '#EE2C4A'}}>*</span>
                  </div>
                  <input
                    onFocus={() => inputFoucs('name')}
                    onChange={(e) => {changeValue('name', e); validate('name')}} 
                    className={message.name === '' ? null : 'input-error'}
                    onBlur={() => validate('name')}
                    type="text"/>
                  {
                    message.name ? <div className="message">{$t(message.name)}</div>: null
                  }
                </div>
                <div className="form-item">
                  <div className="label-container">
                    <span className={message.email === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_2')}</span>
                    <span style={{color: '#EE2C4A'}}>*</span>
                  </div>
                  <input
                    onFocus={() => inputFoucs('email')}
                    className={message.email === '' ? null : 'input-error'}
                    onChange={(e) => {changeValue('email', e)}} 
                    onBlur={() => validate('email')}
                    type="email"/>
                  {
                    message.email ? <div className="message">{$t(message.email)}</div>: null
                  }
                </div>
                <div className="form-item">
                  <div className="label-container">
                    <span className={message.departments === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_3')}</span>
                    <span style={{color: '#EE2C4A'}}>*</span>
                  </div>
                  <SubscribePicker 
                    title={$t('microsite_modal_subscribe_form_label_3')}
                    selectType="multiple"
                    setPickerValue={(value) => {setPickerValue('departments', value)}} 
                    confirmOptions={form.departments}
                    validate={() => validate('departments')}
                    options={deptList} />
                  {
                    message.departments ? <div className="message">{$t(message.departments)}</div>: null
                  }
                </div>
                <div className="form-item">
                  <div className="label-container">
                    <span className={message.levels === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_4')}</span>
                    <span style={{color: '#EE2C4A'}}>*</span>
                  </div>
                  <SubscribePicker 
                    title={$t('microsite_modal_subscribe_form_label_4')}
                    setPickerValue={(value) => {setPickerValue('levels', value)}} 
                    confirmOptions={form.levels}
                    validate={() => validate('levels')}
                    options={levelList} />
                  {
                    message.levels ? <div className="message">{$t(message.levels)}</div>: null
                  }
                </div>
                <div className="form-item">
                  <div className="label-container">
                    <span className={message.regions === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_5')}</span>
                    <span style={{color: '#EE2C4A'}}>*</span>
                  </div>
                  <SubscribePicker 
                    title={$t('microsite_modal_subscribe_form_label_5')}
                    selectType="multiple"
                    setPickerValue={(value) => {setPickerValue('regions', value)}} 
                    confirmOptions={form.regions}
                    validate={() => validate('regions')}
                    options={locationList} />
                  {
                    message.regions ? <div className="message">{$t(message.regions)}</div>: null
                  }
                </div>
                {/* <div className="form-item"></div> */}
                <div onClick={() => {form.check = !form.check; setForm({...form})}} className="bottom-info">
                  <div className={form.check ? 'reat active' : 'reat'}>
                    <img style={{display: form.check ? 'block' : 'none'}} src={checkWhite} className="check-icon"/>
                  </div>
                  <span className="text">{$t('microsite_modal_subscribe_text_message')}</span>
                </div>
              </form>
            </div>
            <div className="confirm-container">
              <button
                onClick={handleSubmit}
                disabled={!form.check}
                className={form.check ? 'confirm' : 'confirm disabled'}>{$t('microsite_modal_btn_submit')}</button>
            </div>
          </>
        ) : null
      }
    </Popup>
  )
  
}